<template>
  <div v-loading="loading">
    <div class="container" id="node-container">
      <div class="col-md-10 col-md-offset-1">
        <div style="padding: 50px;">
          <div class="text-center">
            <vue2-org-tree
              :data="data"
              :horizontal="horizontal"
              name="test"
              :NodeClass="NodeClass"
              :judge="judge"
              :collapsable = "collapsable"
              @on-node-click="NodeClick"
              @on-expand="onExpand"
             />
          </div>
          <el-card class="box-card" v-if="BasicSwich">
            <div slot="header" class="clearfix">
              <span>{{selectedData.label}}</span>
                <el-button v-if="BasicInfo.length != 0" style="float: right; padding: 3px" type="text" @click="deleteAppr">删除</el-button>
                <el-button v-if="BasicInfo.length != 0" style="float: right; padding: 3px" type="text" @click="addOrUpdateAppr('update',BasicInfo)">修改</el-button>
            </div>
            <div v-if="BasicInfo.length != 0">
              <el-form ref="form" label-width="80px">
                <el-form-item label="姓名">
                  <p class="p">{{filterNull(BasicInfo.empName)}}</p>
                </el-form-item>
                <el-form-item label="部门">
                  <p class="p">{{filterNull(BasicInfo.dept)}}</p>
                </el-form-item>
                <el-form-item label="电话">
                  <p class="p">{{filterNull(BasicInfo.phone)}}</p>
                </el-form-item>
                <el-form-item label="邮箱">
                  <p class="p">{{filterNull(BasicInfo.email)}}</p>
                </el-form-item>
              </el-form>
            </div>
            <div v-else style="text-align: center">
              暂无{{selectedData.label}},<el-button type="text" @click="addOrUpdateAppr('add','')">添加审批人</el-button>
            </div>
          </el-card>
        </div>
      </div>
    </div>
    <add-or-update v-if="dialogVisible" ref="addOrUpdate" @refresh="loadData"></add-or-update>
  </div>
</template>
<script>
  import { getApperNodeListpage} from  "@/api/appr/apprInfo"
  import addOrUpdate from "./addOrUpdate";
  import { citys } from '@/const/city.js';
  export default {
    components: { addOrUpdate },
    data() {
      return {
        BasicSwich: false,
        BasicInfo:[],
        judge: { swtich: true },
        page: {
          pageSizes: [10,20,30,50],
          total: 0,
          currentPage: 1,
          currentPages: 0,
          pageSize: 50
        },
        cityOptions:citys,
        filterParams: {
          processId:''
        },
        NodeClass:[
          "myblue"
        ],
        data: {
          id: "20010001",
          label: "一级审批人",
          swtich: "myblue",
          children: [
            {
              id: "20010002",
              label: "二级审批人",
              swtich: "myblue",
              children: [
                {
                  id: "20010003",
                  label: "三级审批人",
                  swtich: "myblue",
                },
              ]
            },
          ]
        },
        loading:false,
        horizontal: true, //排列方式
        collapsable: true, //展开
        headerTxt:'',
        dataList: [],
        firstLeaveData:[],//一级审批人信息
        secondLeaveData:[],//二级审批人信息
        thirdLeaveData:[],//三级审批人信息
        selectedData:[],//选中的节点信息
        operate:'',//操作
        dialogVisible:false,//弹窗
        isUse:'',
      };
    },
    created() {
    },
    mounted() {
        // 加载参数
        let id = this.$route.query.id;
        if(id){
            this.$set(this.filterParams,'processId',id)
        }
        this.loadData();
    },
    methods: {
      //初始化数据
      loadData(){
        this.BasicSwich = false;
        this.expandChange();
        this.operate = "";
        let params = this.filterParams;
        params.page= this.page.currentPage;
        params.limit = this.page.pageSize;
        this.loading = true;
        getApperNodeListpage(this.filterParams).then(res => {
          this.page.total = res.data.total;
          this.dataList = res.data.records;
          if(this.page.total == 0){
            this.$message.warning("暂未设置审批流程");
            this.isUse = 0;
          }else{
            for(let i = 0; i < this.dataList.length; i++){
              this.$set(this,'isUse',this.dataList[i].status);
              if(this.dataList[i].grade == "20010001"){
                this.$set(this,'firstLeaveData', this.dataList[i]);
              }else if(this.dataList[i].grade == "20010002"){
                this.$set(this,'secondLeaveData', this.dataList[i]);
              }else{
                this.$set(this,'thirdLeaveData', this.dataList[i]);
              }
            }
          }
          this.loading = false;
        })
      },
      //过滤
      filterNull(data){
        return (data == null || data == '') ? '--' : data;
      },
      //新增/修改审批人
      addOrUpdateAppr(operation,BasicInfo){
        let gradeData = this.selectedData;
        this.dialogVisible = true;
        this.$nextTick(() =>{
          this.$refs.addOrUpdate.init(operation,this.isUse,BasicInfo,gradeData,this.filterParams.cityCode);
        })
      },
      //删除审批人
      deleteAppr(){
        this.$confirm("删除将无法恢复，确认删除"+this.selectedData.label+"吗？","提示" , {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: 'warning'
        }).then(() => {
            //删除
            delApprInfoById({"id":this.BasicInfo.id}).then(res =>{
              if(res.data.code == 0 && res.data.data){
                this.operate = "delete";
                this.loading = false;
                this.$message.success("删除成功");
                this.loadData();
              }else{
                this.loading = false;
                this.$message.error("删除失败");
              }
            })
        })
      },
      //节点点击事件
      NodeClick(e, data) {
        this.selectedData = data;
        if(data.id == '20010001'){
          this.$set(this,'BasicInfo', this.firstLeaveData);
        }else if(data.id == '20010002'){
          this.$set(this,'BasicInfo', this.secondLeaveData);
        }else{
          this.$set(this,'BasicInfo', this.thirdLeaveData);
        }
        this.BasicSwich = true;
      },
      onExpand(e, data) {
        if ("expand" in data) {
          data.expand = !data.expand;
          if (!data.expand && data.children) {
            this.collapse(data.children);
          }
        } else {
          this.$set(data, "expand", true);
        }
      },
      collapse(list) {
        var _this = this;
        list.forEach(function(child) {
          if (child.expand) {
            child.expand = false;
          }
          child.children && _this.collapse(child.children);
        });
      },
      expandChange() {
        this.toggleExpand(this.data, true);
      },
      toggleExpand(data, val) {
        var _this = this;
        if (Array.isArray(data)) {
          data.forEach(function(item) {
            _this.$set(item, "expand", val);
            if (item.children) {
              _this.toggleExpand(item.children, val);
            }
          });
        } else {
          this.$set(data, "expand", val);
          if (data.children) {
            _this.toggleExpand(data.children, val);
          }
        }
      }
    },
  };
</script>
<style lang="less">
  #node-container{
    .p{
      padding: 0 20px;
    }
    .p_switch{
      position: absolute;
      top: -8px;
      padding: 0px 15px;
    }
    .el-switch{
      margin-top: 0px !important;
    }
    .myblue{
      background: skyblue;
      color: #fff;
    }
    .text {
      font-size: 14px;
    }
    .item {
      margin-bottom: 18px;
    }
    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }
    .clearfix:after {
      clear: both
    }

    .box-card {
      width: 480px;
    }
    .floating {
      background: rgba(0, 0, 0, 0.7);
      width: 160px;
      height: 100px;
      position: absolute;
      color: #fff;
      padding-top: 15px;
      border-radius: 15px;
      padding-left: 15px;
      box-sizing: border-box;
      left: 0;
      top: 0;
      transition: all 0.3s;
      z-index: 999;
      text-align: left;
      font-size: 12px;
    }
  }
</style>
